/*******************************************************************************
* @ngdoc  service
* @name   AppTools
* @module csm.books.InitialSetup.services
* @description
* Common methods used throughout the application.
*******************************************************************************/
/* @ngInject */ export function AppToolsProvider() {
  this.$get = function () {
    return this.tools;
  };
  this.tools = {
    /*******************************************************************************
     * accountNameValidatorFactory */
    /**
     * @ngdoc  method
     * @name   AppTools#accountNameValidatorFactory
     * @description
     * Called with `$injector.invoke` to return a validator for an Account Name input
     * field that verifies the name is both supplied and unique against all accounts.
     * It returns an error messsage if validation fails. `$oldValue` is original
     * model value.
     *******************************************************************************/
    accountNameValidatorFactory: /* @ngInject */ function (
      $oldValue,
      AppData
    ) {
      return function ($value) {
        if (!$value) return 'Value is required';
        if (
          $value !== $oldValue &&
          AppData.setupData.accounts.some(function (a) {
            return a.accountName === $value;
          })
        )
          return 'Must be unique. This name is in use.';
        return null;
      };
    },

    /*******************************************************************************
     * accountNumberValidatorFactory */
    /**
     * @ngdoc  method
     * @name   AppTools#accountNumberValidatorFactory
     * @description
     * Called with `$injector.invoke` to return a validator for an Account Number
     * input field that verifies the number is both supplied and unique against all
     * accounts. It returns an error messsage if validation fails. `$oldValue` is
     * original model value.
     *******************************************************************************/
    accountNumberValidatorFactory: /* @ngInject */ function (
      $oldValue,
      AppData
    ) {
      return function ($value) {
        if (!$value) return 'Value is required';
        if (
          $value !== $oldValue &&
          AppData.setupData.accounts.some(function (a) {
            return a.accountNumber === $value;
          })
        )
          return 'Must be unique. This number is in use.';
        return null;
      };
    },

    /*******************************************************************************
     * dateString */
    /**
     * @ngdoc  method
     * @name   AppTools#dateString
     * @module csm.books.InitialSetup.services
     * @param  {Date}   date  Date to format.
     * @return {string}       `date` string in "mm/dd/yyy" format or empty string.
     *******************************************************************************/
    dateString: function (date) {
      return isNaN(Date.parse(date))
        ? ''
        : date
            .toISOString()
            .replace(/^(\d{4})\-(\d\d)\-(\d\d).*/, '$2/$3/$1');
    }
  };
};
